import EventEmitter = require("eventemitter3");

class GoogleAnalyticsService {
    private static __instance: GoogleAnalyticsService;
    private emitter: EventEmitter;

    private constructor() {
        if (GoogleAnalyticsService.__instance) throw new Error('Use ApiService.instance() instead of new.');
        GoogleAnalyticsService.__instance = this;
    }

    public static instance(): GoogleAnalyticsService {
        if (!GoogleAnalyticsService.__instance) {
            GoogleAnalyticsService.__instance = new GoogleAnalyticsService();
        }
        return GoogleAnalyticsService.__instance;
    }

    public init(): void {
        this.emitter = new EventEmitter();
    }

    public sendTracking(
        hitType: string = "event",
        eventCategory: string = 'button',
        eventAction: string = 'clicked',
        eventLabel: string = '',
        eventValue: number = -1) {

        ga('send', hitType, eventCategory, eventAction, eventLabel);
    }
}

export = GoogleAnalyticsService;